import { render } from "./ProspectsView.vue?vue&type=template&id=dea3aaa0"
import script from "./ProspectsView.vue?vue&type=script&lang=js"
export * from "./ProspectsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__